var FieldConfig = (function () {
    function FieldConfig(_a) {
        var name = _a.name, entity = _a.entity, iterable = _a.iterable, reflectedEntity = _a.reflectedEntity, deserialize = _a.deserialize, taggedUnion = _a.taggedUnion, nullable = _a.nullable;
        this.name = name;
        this.taggedUnion = taggedUnion;
        this.entity = entity;
        this.reflectedEntity = reflectedEntity;
        this._deserialize = deserialize;
        this.iterable = iterable;
        this.nullable = !!nullable;
    }
    FieldConfig.prototype.initialize = function (_parent) { };
    FieldConfig.prototype.deserialize = function (value) {
        var _this = this;
        var _a;
        var entity = (_a = this.entity) !== null && _a !== void 0 ? _a : this.reflectedEntity;
        var mapSingle = function (v) {
            if (_this._deserialize) {
                return _this._deserialize(v);
            }
            var taggedUnion = _this.taggedUnion;
            if (v != null && taggedUnion != null) {
                var tag = taggedUnion.getTag(v);
                var ent = taggedUnion.handlers[tag];
                if (!ent) {
                    throw new TypeError("designed deserialize error: ".concat(tag, " does not have a matching value inside of ").concat(Object.keys(taggedUnion.handlers).join(", ")));
                }
                if ("fromJSON" in ent) {
                    return ent.fromJSON(v);
                }
                else {
                    return ent(v, tag);
                }
            }
            if (entity && "fromJSON" in entity && v != null) {
                if (typeof v === "object" &&
                    "constructor" in v &&
                    v.constructor === entity) {
                    return v;
                }
                return entity.fromJSON(v);
            }
            return v;
        };
        if (value && this.isArrayLike()) {
            return value.map(mapSingle);
        }
        else {
            return mapSingle(value);
        }
    };
    FieldConfig.prototype.isArrayLike = function () {
        if (this.iterable != null) {
            return this.iterable;
        }
        if (this.reflectedEntity) {
            return (this.reflectedEntity === Array ||
                this.reflectedEntity.prototype instanceof Array);
        }
        return false;
    };
    FieldConfig.prototype.clone = function () {
        var _a = this, reflectedEntity = _a.reflectedEntity, entity = _a.entity, name = _a.name;
        return new FieldConfig({
            reflectedEntity: reflectedEntity,
            entity: entity,
            name: name
        });
    };
    return FieldConfig;
}());
export { FieldConfig };
